import styled from 'styled-components';

export const Iframe = styled.iframe`
  display: block;
  width: 100%;
  max-width: 1024px;
  height: 70vh;
  margin: 0 auto;
  border: 0;
  background-color: var(--color-white);
`;
